import { BorderSketchType } from '@src/slide/domain/ui-model/element-modeles/property/border/constants';

export function isSketchStyle(type?: BorderSketchType): boolean {
    return type === BorderSketchType.CURVED
        || type === BorderSketchType.FREEHAND
        || type === BorderSketchType.SCRIBBLE;
}
